"use client";

import { AlertCircle, ArrowRight, UserCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useGetCurrentUser } from "../hooks/api/users/use-current-user";

export function ProfileCompletionBanner() {
  const { data: user, isLoading } = useGetCurrentUser();
  console.log("user", user);
  if (isLoading || !user) return null;

  const missingFields: string[] = [];
  if (!user?.data.nom) missingFields.push("nom");
  if (!user?.data.prenom) missingFields.push("prénom");
  if (!user?.data.phone_number) missingFields.push("téléphone");

  if (missingFields.length === 0) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      className="flex items-center justify-between gap-3 border-b border-amber-300/60 bg-amber-50 px-4 py-2.5 dark:border-amber-700/40 dark:bg-amber-950/40"
    >
      <div className="flex min-w-0 items-center gap-2.5">
        <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-amber-100 ring-1 ring-amber-300/60 dark:bg-amber-900/60 dark:ring-amber-700/40">
          <AlertCircle className="h-4 w-4 text-amber-600 dark:text-amber-400" aria-hidden="true" />
        </div>
        <div className="flex min-w-0 flex-wrap items-center gap-x-1.5 gap-y-0.5">
          <UserCircle className="h-3.5 w-3.5 shrink-0 text-amber-600 dark:text-amber-400" aria-hidden="true" />
          <span className="text-xs font-semibold text-amber-800 dark:text-amber-300">
            Profil incomplet
          </span>
          <span className="text-xs text-amber-700/80 dark:text-amber-400/80">
            — renseignez votre{" "}
            <span className="font-medium">
              {missingFields.join(", ")}
            </span>{" "}
            pour accéder à toutes les fonctionnalités.
          </span>
        </div>
      </div>

      <Link
        to="/admin/account"
        className="flex shrink-0 items-center gap-1 rounded-md border border-amber-400/60 bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-800 transition-colors duration-150 hover:border-amber-500 hover:bg-amber-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-1 dark:border-amber-700/60 dark:bg-amber-900/50 dark:text-amber-300 dark:hover:bg-amber-900/80"
        aria-label="Compléter mon profil"
      >
        Compléter
        <ArrowRight className="h-3 w-3" aria-hidden="true" />
      </Link>
    </div>
  );
}
